import * as React from 'react';
import Select from 'react-select';
import {
    Button,
    FormControl,
    FormGroup,
    ControlLabel,
    HelpBlock,
    Row,
    Col,
    InputGroup
} from 'react-bootstrap';
import { Translate } from '../../../../shared/LanguageService';
import FormSelect from '../../../../components/common/FormSelect';
import FormValidationService from '../../../../shared/form/FormValidationService';
import ValidatableFormGroup from '../../../../components/common/ValidatableFormGroup';
import { assign } from '../../../../shared/Assign';
import {
    INamedIdentity,
    IProductProperty,
    ISite,
    IEditProduct,
    IProductType,
    IProductDeliveryTimes
} from '../../Types';
import { TranslatedDynamicLabels, TranslatedLabels } from '../../../../shared/types';
import { StatusSection } from './StatusSection';
import { getSiteName } from '../../../../shared/Site';
import * as Site from '../../../../shared/Site';

interface IProps {
    product: IEditProduct;
    errors: any;
    sites: ISite[];
    productTypes: IProductType[];
    bookingConditions: INamedIdentity[];
    legalEntities: INamedIdentity[];
    productProperties: IProductProperty[];
    productDeliveryTimes: IProductDeliveryTimes[];
    invoiceProductTypes: INamedIdentity[];
    onChange: (product: IEditProduct) => void;
    site: string;
}

export class ProductForm extends React.Component<
    IProps & {
        labels: TranslatedLabels;
        dynamicLabels: TranslatedDynamicLabels;
    },
    void
> {
    constructor(props: IProps, context: any) {
        super(props, context);

        this.handleChange = this.handleChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.handlePropertyChange = this.handlePropertyChange.bind(this);
        this.handleIsPricePropertyOwnerLockedChange =
            this.handleIsPricePropertyOwnerLockedChange.bind(this);
    }

    render() {
        const { labels, dynamicLabels } = this.props;

        return (
            <div>
                <FormGroup
                    className="required"
                    controlId="product-name"
                    validationState={FormValidationService.getValidationState(
                        this.props.errors.name
                    )}
                >
                    <ControlLabel>{labels.name}</ControlLabel>
                    <FormControl
                        autoFocus
                        type="text"
                        name="name"
                        value={this.props.product.name ? this.props.product.name : ''}
                        error={this.props.errors.name}
                        onChange={this.handleChange}
                    />
                    <HelpBlock>{this.props.errors.name}</HelpBlock>
                </FormGroup>
                <FormGroup
                    className="required"
                    controlId="description"
                    validationState={FormValidationService.getValidationState(
                        this.props.errors.description
                    )}
                >
                    <ControlLabel>{labels.description}</ControlLabel>
                    <FormControl
                        type="text"
                        name="description"
                        value={this.props.product.description ? this.props.product.description : ''}
                        error={this.props.errors.description}
                        onChange={this.handleChange}
                    />
                    <HelpBlock>{this.props.errors.description}</HelpBlock>
                </FormGroup>
                <Row className="product-price-row">
                    <Col md={3} className="product-price-column">
                        <FormGroup
                            className="required"
                            controlId="priceBrokerFirm"
                            validationState={FormValidationService.getValidationState(
                                this.props.errors.priceBrokerFirm
                            )}
                        >
                            <ControlLabel>{labels.priceBrokerFirm}</ControlLabel>
                            <FormControl
                                type="number"
                                name="priceBrokerFirm"
                                value={
                                    this.props.product.priceBrokerFirm
                                        ? this.props.product.priceBrokerFirm
                                        : ''
                                }
                                onChange={this.handleChange}
                            />
                            <HelpBlock>{this.props.errors.priceBrokerFirm}</HelpBlock>
                        </FormGroup>
                    </Col>
                    <Col md={3} className="product-price-column">
                        <FormGroup
                            className="required"
                            controlId="photographerCompensation"
                            validationState={FormValidationService.getValidationState(
                                this.props.errors.photographerCompensation
                            )}
                        >
                            <ControlLabel>{labels.photographerCompensation}</ControlLabel>
                            <FormControl
                                type="number"
                                name="photographerCompensation"
                                value={
                                    this.props.product.photographerCompensation
                                        ? this.props.product.photographerCompensation.toString()
                                        : ''
                                }
                                onChange={this.handleChange}
                            />
                            <HelpBlock>{this.props.errors.photographerCompensation}</HelpBlock>
                        </FormGroup>
                    </Col>
                    <Col md={3} className="product-price-column">
                        <FormGroup controlId="photographerCompensationForSplitOrder">
                            <ControlLabel>
                                {labels.photographerCompensationForSplitOrder}
                            </ControlLabel>
                            <FormControl
                                type="number"
                                name="photographerCompensationForSplitOrder"
                                value={
                                    this.props.product.photographerCompensationForSplitOrder
                                        ? this.props.product.photographerCompensationForSplitOrder.toString()
                                        : ''
                                }
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={3} className="product-price-column">
                        <FormGroup
                            className="required"
                            controlId="pricePropertyOwner"
                            validationState={FormValidationService.getValidationState(
                                this.props.errors.pricePropertyOwner
                            )}
                        >
                            <ControlLabel>{labels.pricePropertyOwner}</ControlLabel>
                            <InputGroup>
                                <InputGroup.Button>
                                    <Button onClick={this.handleIsPricePropertyOwnerLockedChange}>
                                        {this.props.product.isPricePropertyOwnerLocked && (
                                            <i className="material-icons">lock_outline</i>
                                        )}
                                        {!this.props.product.isPricePropertyOwnerLocked && (
                                            <i className="material-icons">lock_open</i>
                                        )}
                                    </Button>
                                </InputGroup.Button>
                                <FormControl
                                    type="number"
                                    name="pricePropertyOwner"
                                    disabled={this.props.product.isPricePropertyOwnerLocked}
                                    value={
                                        this.props.product.isPricePropertyOwnerLocked
                                            ? this.props.product.priceBrokerFirm
                                                ? (
                                                      this.props.product.priceBrokerFirm * 1.5
                                                  ).toString()
                                                : ''
                                            : this.props.product.pricePropertyOwner
                                            ? this.props.product.pricePropertyOwner.toString()
                                            : ''
                                    }
                                    onChange={this.handleChange}
                                />
                                <HelpBlock>{this.props.errors.pricePropertyOwner}</HelpBlock>
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <FormGroup controlId="externalCost">
                            <ControlLabel>{labels.externalCost}</ControlLabel>
                            <FormControl
                                type="number"
                                name="externalCost"
                                value={
                                    this.props.product.externalCost
                                        ? this.props.product.externalCost.toString()
                                        : ''
                                }
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup controlId="numberOfImages">
                            <ControlLabel>{labels.numberOfImages}</ControlLabel>
                            <FormControl
                                type="number"
                                name="numberOfImages"
                                disabled={this.props.product.isSystem}
                                value={
                                    this.props.product.numberOfImages
                                        ? this.props.product.numberOfImages
                                        : ''
                                }
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup controlId="execution-time">
                            <ControlLabel>{labels.executionTime}</ControlLabel>
                            <FormControl
                                type="number"
                                name="executionTime"
                                disabled={this.props.product.isSystem}
                                value={
                                    this.props.product.executionTime
                                        ? this.props.product.executionTime.toString()
                                        : ''
                                }
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                {['2', '3'].indexOf(this.props.product.type) === -1 && (
                    <Row>
                        <Col md={4}>
                            <FormGroup
                                className="required"
                                controlId="delivery-time"
                                validationState={FormValidationService.getValidationState(
                                    this.props.errors.deliveryTime
                                )}
                            >
                                <ControlLabel>{labels.deliveryTime}</ControlLabel>
                                <FormSelect
                                    name="deliveryTime"
                                    disabled={this.props.product.isSystem}
                                    onChange={this.handleChange}
                                    value={this.props.product.deliveryTime}
                                    defaultTranslateKey="products/modal/form/select-label/choose-delivery-time"
                                >
                                    {this.props.productDeliveryTimes &&
                                        this.props.productDeliveryTimes.map((e: any) => {
                                            return (
                                                <option key={e} value={e}>
                                                    {e} {labels.deliveryTimeHour}
                                                </option>
                                            );
                                        })}
                                </FormSelect>
                                <HelpBlock>
                                    {dynamicLabels.productDeliveryTime(
                                        this.props.errors.productDeliveryTime
                                    )}
                                </HelpBlock>
                            </FormGroup>
                        </Col>
                    </Row>
                )}
                <StatusSection
                    labels={{
                        status: labels.status,
                        isDiscontinued: labels.isDiscontinued,
                        isVisibleToCustomer: labels.isVisibleToCustomer,
                        isPhotographerProduct: labels.isPhotographerProduct,
                        isPhotographerPreChosen: labels.isPhotographerPreChosen,
                        isPossibleToSplitFromOrder: labels.isPossibleToSplitFromOrder,
                        uploadable: labels.uploadable,
                        isStylingProduct: labels.isStylingProduct
                    }}
                    product={this.props.product}
                    onAnyChange={this.handleCheckboxChange}
                />
                <Row>
                    <Col md={4}>
                        <FormGroup
                            className="required"
                            controlId="site"
                            validationState={FormValidationService.getValidationState(
                                this.props.errors.site
                            )}
                        >
                            <ControlLabel>{labels.site}</ControlLabel>
                            <FormSelect
                                name="site"
                                disabled={this.props.product.isSystem}
                                onChange={this.handleChange}
                                value={this.props.product.site}
                                defaultTranslateKey="products/modal/form/select-label/choose-site"
                            >
                                {this.props.site === getSiteName(Site.Zentuvo) ? (
                                    <option value={1} key={1}>
                                        {'Zentuvo'}
                                    </option>
                                ) : (
                                    <>
                                        {this.props.sites.map((e: any) => {
                                            return (
                                                <option key={e.id} value={e.id}>
                                                    {e.name}
                                                </option>
                                            );
                                        })}
                                    </>
                                )}
                            </FormSelect>
                            <HelpBlock>{dynamicLabels.site(this.props.errors.site)}</HelpBlock>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup
                            className="required"
                            controlId="product-type"
                            validationState={FormValidationService.getValidationState(
                                this.props.errors.type
                            )}
                        >
                            <ControlLabel>{labels.productType}</ControlLabel>
                            <FormSelect
                                name="type"
                                disabled={this.props.product.isSystem}
                                onChange={this.handleChange}
                                value={this.props.product.type}
                                defaultTranslateKey="products/modal/form/select-label/type"
                            >
                                {this.props.productTypes.map((t: any) => {
                                    return (
                                        <option key={t.id} value={t.id}>
                                            {t.name}
                                        </option>
                                    );
                                })}
                            </FormSelect>
                            <HelpBlock>{this.props.errors.type}</HelpBlock>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <ValidatableFormGroup
                            required
                            controlId="invoice-product-type"
                            errors={this.props.errors}
                            validationKey="invoiceProductType"
                        >
                            <ControlLabel>{labels.invoiceProductType}</ControlLabel>
                            <FormSelect
                                name="invoiceProductType"
                                disabled={this.props.product.isSystem}
                                onChange={this.handleChange}
                                value={this.props.product.invoiceProductType}
                                defaultTranslateKey="products/modal/form/input-default/select-invoice-product-type"
                            >
                                {this.invoiceProductTypesForSite(this.props.product.site).map(
                                    (type: any) => {
                                        return (
                                            <option key={type.id} value={type.id}>
                                                {type.name}
                                            </option>
                                        );
                                    }
                                )}
                            </FormSelect>
                        </ValidatableFormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup
                            className="required"
                            controlId="booking-condition"
                            validationState={FormValidationService.getValidationState(
                                this.props.errors.bookingCondition
                            )}
                        >
                            <ControlLabel>{labels.bookingCondition}</ControlLabel>
                            <FormSelect
                                name="bookingCondition"
                                disabled={this.props.product.isSystem}
                                onChange={this.handleChange}
                                value={this.props.product.bookingCondition}
                            >
                                {this.props.bookingConditions.map((b: any) => {
                                    return (
                                        <option key={b.id} value={b.id}>
                                            {b.name}
                                        </option>
                                    );
                                })}
                            </FormSelect>
                            <HelpBlock>{this.props.errors.bookingCondition}</HelpBlock>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup
                            className="required"
                            controlId="legal-entity"
                            validationState={FormValidationService.getValidationState(
                                this.props.errors.legalEntity
                            )}
                        >
                            <ControlLabel>{labels.legalEntity}</ControlLabel>
                            <FormSelect
                                name="legalEntity"
                                disabled={this.props.product.isSystem}
                                onChange={this.handleChange}
                                value={this.props.product.legalEntity}
                                defaultTranslateKey="products/modal/form/input-label/choose-legal-entity"
                            >
                                {this.props.legalEntities.map((e: any) => {
                                    return (
                                        <option key={e.id} value={e.id}>
                                            {e.name}
                                        </option>
                                    );
                                })}
                            </FormSelect>
                            <HelpBlock>{this.props.errors.legalEntity}</HelpBlock>
                        </FormGroup>
                    </Col>
                    <Col md={12}>
                        <FormGroup controlId="product-properties">
                            <ControlLabel>{labels.productProperties}</ControlLabel>
                            <Select
                                isMulti
                                closeMenuOnSelect={false}
                                isDisabled={this.props.product.isSystem}
                                value={this.getValues()}
                                placeholder={Translate(
                                    'products/modal/form/select-label/placeholder/choose-product-properties'
                                )}
                                options={this.getOptions()}
                                onChange={this.handlePropertyChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <FormGroup controlId="extra-text">
                    <ControlLabel>{labels.extraText}</ControlLabel>
                    <FormControl
                        type="text"
                        name="extraText"
                        value={this.props.product.extraText ? this.props.product.extraText : ''}
                        error={this.props.errors.extraText}
                        onChange={this.handleChange}
                    />
                </FormGroup>
                <FormGroup controlId="photographer-instructions">
                    <ControlLabel>{labels.photographerInstructions}</ControlLabel>
                    <FormControl
                        type="text"
                        name="photographerInstructions"
                        value={
                            this.props.product.photographerInstructions
                                ? this.props.product.photographerInstructions
                                : ''
                        }
                        error={this.props.errors.photographerInstructions}
                        onChange={this.handleChange}
                    />
                </FormGroup>
            </div>
        );
    }

    getOptions = () => {
        return this.props.productProperties
            .filter((p: any) => {
                if (this.props.product.properties && this.props.product.properties.includes(p.id)) {
                    return true;
                }

                if (this.props.product.type && this.props.product.site && p.selectable) {
                    if ((p.validForSites & parseInt(this.props.product.site)) > 0) {
                        if (!p.validForProductTypes) {
                            return true;
                        } else {
                            let productTypeType = this.props.productTypes.find(
                                (p: any) => p.id === parseInt(this.props.product.type)
                            ).productTypeType;
                            return p.validForProductTypes.indexOf(productTypeType) > -1;
                        }
                    }
                    return false;
                }
            })
            .map((p: any) => {
                return { value: p.id, label: Translate(p.name) };
            });
    };

    getValues = () => {
        return this.props.productProperties
            .filter(
                (p) => this.props.product.properties && this.props.product.properties.includes(p.id)
            )
            .map((p) => ({
                value: p.id,
                label: Translate(p.name)
            }));
    };

    invoiceProductTypesForSite(site) {
        if (!site) {
            return [];
        }

        return this.props.invoiceProductTypes.filter((x) => x.site.toString() === site.toString());
    }

    handleChange(e: any) {
        let product = this.props.product;

        product[e.target.name] = e.target.value;

        this.changeProductState(product);
    }

    handleCheckboxChange(e: any) {
        let product = this.props.product;

        product[e.target.name] = e.target.checked;

        if (e.target.name === 'isStylingProduct' && e.target.checked) {
            product.isPhotographerProduct = false;
        } else if (e.target.name === 'isPhotographerProduct' && e.target.checked) {
            product.isStylingProduct = false;
        }

        this.changeProductState(product);
    }

    handlePropertyChange(values: any[]) {
        let product = assign({}, this.props.product);

        product['properties'] = values.map(({ value }) => value);
        this.changeProductState(product);
    }

    handleDropdownChange(value: number, field: string) {
        let product = this.props.product;
        product[field] = value;

        this.changeProductState(product);
    }

    handleIsPricePropertyOwnerLockedChange() {
        let product = this.props.product;
        product.isPricePropertyOwnerLocked = !product.isPricePropertyOwnerLocked;

        this.changeProductState(product);
    }

    changeProductState(product: any) {
        this.props.onChange(product);
    }
}

function TranslatedProductForm(props: IProps) {
    const labels: TranslatedLabels = {
        name: Translate('products/modal/form/input-label/name'),
        description: Translate('products/modal/form/input-label/description'),
        priceBrokerFirm: Translate('products/modal/form/input-label/price-broker-firm'),
        photographerCompensation: Translate(
            'products/modal/form/input-label/photographer-compensation'
        ),
        photographerCompensationForSplitOrder: Translate(
            'products/modal/form/input-label/photographer-compensation-for-split-order'
        ),
        pricePropertyOwner: Translate('products/modal/form/input-label/price-property-owner'),
        externalCost: Translate('products/modal/form/input-label/external-cost'),
        numberOfImages: Translate('products/modal/form/input-label/number-of-images'),
        executionTime: Translate('products/modal/form/input-label/execution-time'),
        deliveryTime: Translate('products/modal/form/select-label/delivery-time'),
        deliveryTimeHour: Translate('products/modal/form/select-label/delivery-time-hour'),
        status: Translate('products/modal/form/legend/status'),
        isDiscontinued: Translate('products/modal/form/checkbox-label/is-discontinued'),
        isVisibleToCustomer: Translate('products/modal/form/checkbox-label/is-visible-to-customer'),
        isPhotographerProduct: Translate(
            'products/modal/form/checkbox-label/is-photographer-product'
        ),
        isPhotographerPreChosen: Translate(
            'products/modal/form/checkbox-label/is-photographer-pre-chosen'
        ),
        isPossibleToSplitFromOrder: Translate(
            'products/modal/form/checkbox-label/is-possible-to-split-from-order'
        ),
        uploadable: Translate('products/modal/form/checkbox-label/uploadable'),
        isStylingProduct: Translate('products/modal/form/checkbox-label/is-styling-product'),
        site: Translate('products/modal/form/select-label/site'),
        productType: Translate('products/modal/form/select-label/type'),
        invoiceProductType: Translate('products/modal/form/input-label/invoice-product-type'),
        bookingCondition: Translate('products/modal/form/select-label/booking-condition'),
        legalEntity: Translate('products/modal/form/input-label/legal-entity'),
        productProperties: Translate('products/modal/form/select-label/product-properties'),
        extraText: Translate('products/modal/form/input-label/extra-text'),
        photographerInstructions: Translate(
            'products/modal/form/input-label/photographer-instructions'
        )
    };

    const dynamicLabels: TranslatedDynamicLabels = {
        productDeliveryTime: (translationKey: string): string => Translate(translationKey),
        site: (translationKey: string): string => Translate(translationKey)
    };

    return (
        <ProductForm {...props} labels={labels} dynamicLabels={dynamicLabels} site={props.site} />
    );
}

export default TranslatedProductForm;
